import dynamic from "next/dynamic";

const Testimonials = dynamic(() => import("@/app/parts/testimonials/Testimonials"));
import quote from "@/styles/modules/testimonials.module.scss";
import { TestimonialService } from "@api";

export interface TestimonialsProps {
    isHome?: boolean;
}


export default async function TestimonialsWrapper(props: TestimonialsProps)
{
    const data = await TestimonialService.get();

    // Shuffle once here, on the server. For the static export this runs at build time, so the
    // order is baked into the HTML and serialized to the client identically. Previously the
    // client component shuffled with Math.random() during render, so SSR and the client produced
    // different orders -> React hydration mismatch (#418, text). Shuffling server-side keeps the
    // varied order without the mismatch (and without a post-mount reshuffle that would cause CLS).
    const shuffled = [...data].sort(() => Math.random() - 0.5);

    return (
        <section className={quote.testimonials__wrapper}>
            <div className="container">
                <Testimonials data={shuffled} isHome={props.isHome ?? false} />
            </div>
        </section>
    );
}